import { matchPath } from 'react-router-dom';

/**
 * V3-043: the page name for the browser tab on every route ("[Page] – DRM WRAP", see
 * hooks/useDocumentTitle). Each name is the page's own title (V3-042: menu label = page title =
 * route). Detail routes name the kind of record; a page that knows the record's name (a vendor, a
 * unit) refines it with useDocumentTitle.
 *
 * Order matters only where patterns overlap: the first match wins, so specific paths come before
 * their `:param` siblings.
 */
export const PAGE_TITLES: ReadonlyArray<readonly [pattern: string, title: string]> = [
  ['/login', 'Sign In'],
  ['/home', 'Home'],
  ['/tasks', 'Tasks'],
  ['/tasks/:view', 'Tasks'],
  ['/standing-tasks', 'Standing Tasks'],
  ['/schedule', 'Schedule'],
  ['/projects', 'Projects'],
  ['/projects/:id', 'Project'],
  ['/submissions', 'Submissions'],
  ['/forms', 'Submissions'],
  ['/hired-equipment/grid', 'New Hired Equipment'],
  ['/purchase-orders', 'Purchase Orders'],
  ['/purchase-orders/:id', 'Purchase Order'],
  ['/vendors', 'Vendors'],
  ['/vendors/:id', 'Vendor'],
  ['/resources', 'Resources'],
  ['/vendor-approvals', 'Vendor Approvals'],
  ['/material-locations', 'Material Locations'],
  ['/material-locations/*', 'Material Locations'],
  ['/equipment', 'Equipment'],
  ['/equipment/*', 'Equipment'],
  ['/pcrs', 'PCRs'],
  ['/work-ids', 'Work IDs'],
  ['/reports', 'Reports'],
  ['/message-center', 'Message Center'],
  ['/employees', 'Employees'],
  ['/classifications', 'Classifications & Rates'],
  ['/roles', 'Roles & Permissions'],
  ['/activities', 'Activities'],
  ['/areas', 'Areas'],
  ['/areas/:section', 'Areas'],
  ['/assets', 'Assets'],
  ['/vehicles', 'Vehicles'],
  ['/vehicles/new', 'Create New Vehicle'],
  ['/vehicles/:id', 'Vehicle'],
  ['/vehicle-profiles', 'Vehicle Profiles'],
  ['/admin/fuel-surcharge', 'Fuel Surcharge'],
  ['/admin/data-sources/animal-types', 'Animal Types'],
  ['/admin/data-sources/chris-properties', 'CHRIS Properties'],
  ['/admin/data-sources/rockfall', 'Rockfall'],
  ['/admin/data-sources/wars', 'WARS'],
  ['/test-bugsnag', 'Bugsnag Test'],
];

/** The page title for a pathname, or "Page Not Found" for a route the app does not have. */
export function pageTitleForPath(pathname: string): string {
  for (const [pattern, title] of PAGE_TITLES) {
    if (matchPath({ path: pattern, end: true }, pathname)) return title;
  }
  return 'Page Not Found';
}
